import React from "react";
import "./Unlock_Your_Potential.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faRocket } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Unlock_Your_Potential = () => {
  return (
    <section className="Unlock_Your_Potential">
      <div className="container">
        <div className="Unlock_Your_Potential_div">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 ">
              <div className="left_col_img">
                <img
                  src="/assets/images/home/Industry_Standard/new1.jpeg"
                  alt="certificate"
                  className="certificate_img"
                />
              </div>
            </div>

            <div className="col-lg-7 col-md-7 ">
              <div className="right_col_div">
                <div className="blue_strip">
                  <p className="blue_strip_text">
                    <span className="blue_icon_span">
                      <FontAwesomeIcon
                        icon={faRocket}
                        style={{ color: "#fff" }}
                      />
                    </span>{" "}
                    {""}
                    Ready to Make the Switch? Transform Your Career Today
                  </p>
                </div>

                <h4 className="right_title">
                  UNLOCK YOUR HIGH POTENTIAL WITH <span>PST IT SOLUTIONS!</span>
                </h4>

                <p className="right_text">
                  PST Academy offers a structured, flexible, and guided learning
                  program for working professionals in tech to accelerate their
                  careers. The programs are open to all working professionals in
                  tech irrespective of their years of experience.
                </p>

                <div className="certified_btn_div">
                  <Link to={"/claim-certificate"}>
                  <button className="certified_btn" type="submit" >
                    Get Certified
                    <span>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        style={{ color: "#fff" }}
                        className="btn_icon"
                      />
                    </span>
                  </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Unlock_Your_Potential;
